import { render, staticRenderFns } from "./VoiceSynthesis.vue?vue&type=template&id=1ac1f2fc&scoped=true&"
import script from "./VoiceSynthesis.vue?vue&type=script&lang=js&"
export * from "./VoiceSynthesis.vue?vue&type=script&lang=js&"
import style0 from "./VoiceSynthesis.vue?vue&type=style&index=0&id=1ac1f2fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac1f2fc",
  null
  
)

export default component.exports